import React from 'react'
import {FormattedMessage} from "react-intl"
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers'

export function TypeColumnFormatter(typeID: number) {
  const prefix = 'notifications-type';
  const getType = () => {
    switch (typeID) {
      case 1:
        return (
          <div
            className="badge badge-pill w-150px font-size-h4 text-nowrap"
            style={{
              background: '#F9F4E5',
              border: '1px solid rgb(253, 185, 19)',
              color: 'rgb(253, 185, 19)',
            }}
          >
            <img
              src={toAbsoluteUrl('/media/common/Mail_orange.svg')}
              alt="email" className="mr-2 w-20px h-20px"
            />
            <FormattedMessage id={`${prefix}-email`} defaultMessage="Email"/>
          </div>
        )
      case 2:
        return (
          <div
            className="badge badge-pill w-150px font-size-h4 text-nowrap"
            style={{
              background: '#E3F0FB',
              border: '1px solid rgb(56, 189, 248)',
              color: 'rgb(56, 189, 248)'
          }}
          >
            <img
              src={toAbsoluteUrl('/media/common/SMS_primary.svg')}
              alt="sms" className="mr-2 w-20px h-20px"
            />
            <FormattedMessage id={`${prefix}-sms`} defaultMessage="SMS"/>
          </div>
        )
      case 3:
        return (
          <div
            className="badge badge-pill w-150px font-size-h4 text-nowrap"
            style={{
              background: '#CDEADB',
              border: '1px solid rgb(65, 141, 88)',
              color: 'rgb(65, 141, 88)',
            }}
          >
            <img
              src={toAbsoluteUrl('/media/common/Whatsapp_green.svg')}
              alt="whatsapp" className="mr-2 w-20px h-20px"
            />
            <FormattedMessage id={`${prefix}-whatsapp`} defaultMessage="Whatsapp"/>
          </div>
        )
      default:
        return null
    }
  }

  return getType()
}